import { useGetClientByIdQuery, useGetIndividualArticlesQuery } from '@entities/clients/rtk-query.ts';
import { useModules } from '@entities/common/index.ts';
import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useArticleLargeCarPagedRedirect } from '@pages/articles/articlePage/helpers.ts';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import * as listStyles from '@features/clients/articles_and_programs_list/common/list_styles.module.scss';
import { ListCard } from '@features/clients/articles_and_programs_list/common/ui/index.ts';
import { Blank } from '@src/library/components/common/index.ts';

type PT = {
  clientId: number;
};

export const RentedArticleList = ({ clientId }: PT) => {
  const location = useLocation();
  const { doSavePageUrl } = useArticleLargeCarPagedRedirect();
  const [page, setPage] = useState(1);
  const { modules } = useModules();
  const { data: client, isLoading: isClientLoading } = useGetClientByIdQuery(clientId);

  const articleModule = useMemo(() => {
    return modules.find((el) => el.module_type === 'articles');
  }, [modules]);

  const { data: individualArticles, isLoading: isIndividualArticlesLoading } =
    useGetIndividualArticlesQuery(
      {
        clientId: client?.id as number,
        page: page,
      },
      { skip: isClientLoading || !client }
    );

  const articles = useMemo(() => individualArticles?.results || [], [individualArticles]);
  const isLoading = isClientLoading || isIndividualArticlesLoading;

  return (
    <InfinityList
      hasMore={Boolean(individualArticles?.next)}
      loadMore={() => setPage((page) => page + 1)}
      loading={isLoading}
      className={listStyles.list}
    >
      {!isLoading && !articles.length && <Blank text="Здесь пока нет статей" />}

      {articles.map((article) => {
        const { id, title, author, created, cover } = article;
        return (
          <Link
            to={`/${articleModule?.module_type}/${articleModule?.code}/${id}`}
            key={id}
            state={location}
            onClick={doSavePageUrl}
          >
            <ListCard author={author} title={title} img={cover} created={created} />
          </Link>
        );
      })}
    </InfinityList>
  );
};
